/**
 * 与 axios `client` 共用的 API 基址（VITE_API_BASE_URL），
 * 供 fetch 场景（如 /v1/chat/completions）与 REST 走同一后端。
 */
export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL?.trim()
  if (!raw) return ''
  return normalizeOrigin(raw)
}

/** 去掉首尾空格与末尾 `/` */
export function normalizeOrigin(url: string): string {
  return url.trim().replace(/\/+$/, '')
}

/**
 * SDK / relay 对外根地址：优先 status.server_address，其次绝对 VITE_API_BASE_URL，最后当前页 origin。
 */
export function getRelayOrigin(serverAddress?: string | null): string {
  const fromStatus = serverAddress?.trim()
  if (fromStatus) return normalizeOrigin(fromStatus)

  const viteBase = import.meta.env.VITE_API_BASE_URL?.trim()
  if (viteBase && /^https?:\/\//i.test(viteBase)) {
    return normalizeOrigin(viteBase)
  }

  if (typeof window !== 'undefined') {
    return window.location.origin
  }

  return ''
}

/** 安全拼接 relay 根地址与路径，避免 `//` 与重复斜杠 */
export function joinRelayPath(origin: string, path: string): string {
  const base = normalizeOrigin(origin)
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  if (!base) return normalizedPath
  return `${base}${normalizedPath}`
}

/**
 * 将路径解析为可请求的 URL。base 为空时使用以 `/` 开头的相对路径（由当前页源或 dev 代理解析）。
 */
export function resolveApiPath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`
  const base = getApiBaseUrl()
  if (!base) return p
  return `${base}${p}`
}
